(function($, Drupal, once) {

  Drupal.behaviors.two_col_comparison = {
    attach: function (context, settings) {
      // Mobile Version
      $('.two-column-comparison-mobile').each(function(){
        const comparisonMobile = $(this);

        // Return if already initialised
        if (comparisonMobile.attr('data-initialised') !== undefined)
          return;

        // Mark as initialised
        comparisonMobile.attr('data-initialised', true);

        // Get all items
        const items = comparisonMobile.find('.two-column-comparison-mobile__item');

        // Set the first item as active
        items.first().addClass('active');

        comparisonMobile.on('click', '.two-column-comparison-mobile__item .toggle', function(event) {
          // Prevent the default action
          event.preventDefault();

          // Get the clicked element as a jQuery object
          const selectedItem = $(this);

          // Unselect existing item
          items.removeClass('active');

          // Select the new item
          selectedItem.closest('.two-column-comparison-mobile__item').addClass('active');

          const headerHeight = $('header').outerHeight() + 100;
          const elementOffset = selectedItem.offset().top;
          const scrollPosition = elementOffset - headerHeight;

          $(window).scrollTop(scrollPosition);
        });
      });

      // Desktop Version
      $('.two-column-comparison').each(function() {
        const comparison = $(this);

        // Return if already initialised
        if (comparison.attr('data-initialised') !== undefined)
          return;

        // Mark as initialised
        comparison.attr('data-initialised', true);

        // Get toggles and content
        const toggles = comparison.find('.two-column-comparison__item__toggle');
        const contents = comparison.find('.two-column-comparison__content');

        // Set the first toggle and content as active
        toggles.first().addClass('active');
        contents.first().addClass('active');

        comparison.on('click', '.two-column-comparison__item__toggle', function(event) {
          // Prevent the default action
          event.preventDefault();

          // Get the clicked element as a jQuery object
          const $selectedToggle = $(this);

          // Deselect existing selection
          toggles.removeClass('active');
          contents.removeClass('active');

          // Select the new toggle and content
          $selectedToggle.addClass('active');
          console.log($selectedToggle);

          // Find and activate the corresponding content
          comparison.find('[data-comparison-content-title="' + $selectedToggle.attr('data-comparison-toggle-title') + '"]').addClass('active');

          return false;
        });
      });

    }
  }

})(jQuery, Drupal, once)




